export class TopListDataRequestModel {
    public resultCount?: number;
    public sortFormula?: string;
    public collaborate?: string;
    public singleSymbol?: string;
    public skipMetaData?: boolean;
    public streaming?: boolean;
    public collaborateColumns?: boolean;
    public outsideMarketHours?: boolean;
    public extraColumns: Array<string> = [];

    public addExtraColumn(column: string) {
        if (column) {
            this.extraColumns.push(column);
        }
    }
}